import { inject, Service } from '@angular/core';
import { Resolve } from '@angular/router';
import { OwnerPlanner } from '@h5s/entities';
import { defer, from, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { FeatureOwnerService } from '../feature-owner.service';

/**
 * Resolver per caricare le impostazioni dell'OwnerPlanner prima di attivare le rotte che ne fanno uso.
 * Se le impostazioni sono già caricate, non fa nulla.
 * Se non sono caricate, chiama il metodo loadOwnerSettings() del FeatureOwnerService.
 */
@Service()
export class OwnerPlannerResolver implements Resolve<OwnerPlanner | null> {
  /** Services */
  private readonly featureOwnerService = inject(FeatureOwnerService);

  resolve(): Observable<OwnerPlanner | null> {
    return defer(() => {
      const ownerPlanner = this.featureOwnerService.ownerPlannerSettings();
      if (ownerPlanner) return of(ownerPlanner);

      return from(this.featureOwnerService.loadPlannerSettings()).pipe(
        switchMap(() => of(this.featureOwnerService.ownerPlannerSettings())),
      );
    });
  }
}
